import { customReportsUrl } from "API/urls/customReports.api";
import { axiosInstance } from "configs/axios";

export const executeQueryApi = async (sqlQuery) => {
  try {
    const response = await axiosInstance.post(customReportsUrl.executeQuery, {
      sqlQuery: sqlQuery,
    });
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
